import { externalLinks } from './site'

// Editable event data — the single source for the homepage section, the Events
// page card view, and the Events page list/calendar view.
// Only add events that have been confirmed by the BCM team.

export type BcmEvent = {
  id: string
  category: 'Fall 2026' | 'Weekly' | 'Coming Soon'
  title: string
  /** Human readable date or schedule label. */
  date: string
  /** Leave undefined when a time has not been confirmed. */
  time?: string
  /** Short location line (used in compact cards). */
  location?: string
  /** Fuller location sentence (used on the Events page). */
  locationDetail?: string
  /** Shown in place of a location when details are still pending. */
  locationNote?: string
  description: string
  /** Extra note shown under the details on the Events page. */
  clarification?: string
  /** Optional verified external call to action. */
  cta?: { label: string; href: string }
  /** Optional verified external reference link. */
  reference?: { label: string; href: string }
  /** Sortable key for the list view. Weekly/undated entries sort last. */
  sortKey?: string
}

export const upcomingEvents: BcmEvent[] = [
  {
    id: 'first-worship-night-fall-2026',
    category: 'Fall 2026',
    title: 'First Worship Night',
    date: 'Thursday, August 27, 2026',
    time: '7:30 PM',
    locationNote:
      'Final location and event details will be posted after the leadership retreat.',
    description: 'Join UCF BCM for the first worship night of the fall semester.',
    cta: { label: 'Get Updates', href: externalLinks.getConnectedForm },
    sortKey: '2026-08-27',
  },
  {
    id: 'thursday-worship-nights',
    category: 'Weekly',
    title: 'Thursday Worship Nights',
    date: 'Thursdays during the school year',
    time: '7:30 PM',
    location: 'Most weeks: Cape Florida Ballroom, Room 316',
    locationDetail:
      'Most weeks: Cape Florida Ballroom, Room 316, on the third floor of the UCF Student Union.',
    description:
      'Gather for worship, a Bible-centered message, fellowship, and time to meet other students.',
    clarification: 'Check this page or Instagram for the latest weekly location.',
    reference: { label: 'Follow @ucfbcm', href: externalLinks.instagram },
    sortKey: 'recurring',
  },
  {
    id: 'welcome-week-2026',
    category: 'Coming Soon',
    title: 'Welcome Week Events',
    date: 'Schedule coming soon',
    description: 'Final Welcome Week details will be added after the leadership retreat.',
    sortKey: 'tbd',
  },
]

export const announcement = {
  message:
    'First Worship Night: Thursday, August 27 at 7:30 PM • Welcome Week schedule coming soon',
  linkLabel: 'View Events',
  linkTo: '/events',
} as const
